export default "__VITE_ASSET__CmzYuk0W__"